import React from 'react';
import { motion } from 'framer-motion';
const stats = [{
  value: '10k+',
  label: 'Happy Clients'
}, {
  value: '15+',
  label: 'Years Experience'
}, {
  value: '4.9',
  label: 'Average Rating'
}, {
  value: '3',
  label: 'Master Barbers'
}];
export function Stats() {
  return <section className="py-24 px-6 bg-matte-black border-y border-off-white/5" data-id="element-204">
      <div className="max-w-7xl mx-auto" data-id="element-205">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-12" data-id="element-206">
          {stats.map((stat, index) => <motion.div key={stat.label} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="text-center" data-id="element-207">
              <div className="font-playfair text-4xl md:text-6xl font-bold text-soft-gold mb-2" data-id="element-208">
                {stat.value}
              </div>
              <div className="font-inter text-sm md:text-base text-off-white/60 uppercase tracking-widest" data-id="element-209">
                {stat.label}
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}